import React, { useLayoutEffect, useRef } from 'react';
import useOnScreen from '../utils/useOnScreen';
export default function LoadingWidget(props) {
    const ref = useRef();
    const onScreen = useOnScreen(ref, '-50px');
    const { onReached } = props;
    useLayoutEffect(() => {
        if (onScreen && onReached) {
            onReached();
        }
    }, [onScreen, onReached]);
    return (React.createElement("music-shoveler", { ref: ref, style: { display: 'grid', justifyItems: 'center' } },
        React.createElement("div", { style: { width: 24, height: 24 } },
            React.createElement("music-icon", { style: { width: 24, height: 24 }, name: "loader" }))));
}
